<template>
  <div class="carousel-container" :class="sizeClass">
    <div class="carousel-images">
      <img 
        v-if="currentImage.url" 
        :src="currentImage.url" 
        alt="Face" 
        class="carousel-image" 
      />
      <div v-else class="no-image">No Image Available</div>
      
      <div v-if="assets.length > 1" class="carousel-controls">
        <button @click.stop.prevent="prevImage" class="carousel-control carousel-control-prev">
          <i class="material-icons">chevron_left</i>
        </button>
        <button @click.stop.prevent="nextImage" class="carousel-control carousel-control-next">
          <i class="material-icons">chevron_right</i>
        </button>
      </div>
    </div>
    
    <div v-if="assets.length > 1" class="carousel-indicators-wrapper" @click.stop>
      <div v-for="(row, rowIndex) in indicatorRows" :key="'row-' + rowIndex" class="carousel-indicators-row">
        <span v-for="index in row" 
          :key="'dot-' + index" 
          :class="['carousel-dot', { active: currentIndex === index }]"
          @click.stop.prevent="goToImage(index)">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    assets: {
      type: Array,
      required: true,
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'filter',
      validator: (value) => ['filter', 'form', 'incident'].includes(value)
    }
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
    }
  },
  computed: {
    currentImage() {
      return this.assets[this.currentIndex] || {};
    },
    sizeClass() {
      return `carousel-size-${this.size}`;
    },
    indicatorRows() {
      // Return an array of index arrays, each max length 10
      const rows = [];
      for (let i = 0; i < this.assets.length; i += 10) {
        const slice = this.assets.slice(i, i + 10).map((_, idx) => i + idx);
        rows.push(slice);
      }
      return rows;
    }
  },
  watch: {
    assets: {
      handler() {
        this.currentIndex = 0;
        this.restartCarousel();
      },
      deep: true
    }
  },
  mounted() {
    if (this.autoPlay && this.assets.length > 1) {
      this.startCarousel();
    }
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      if (this.assets.length <= 1) return;
      
      this.intervalId = setInterval(() => {
        this.nextImage();
      }, 3000);
    },
    stopCarousel() {
      clearInterval(this.intervalId);
    },
    restartCarousel() {
      this.stopCarousel();
      if (this.autoPlay && this.assets.length > 1) {
        this.startCarousel();
      }
    },
    prevImage(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.currentIndex = (this.currentIndex - 1 + this.assets.length) % this.assets.length;
    },
    nextImage(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.currentIndex = (this.currentIndex + 1) % this.assets.length;
    },
    goToImage(index, e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.currentIndex = index;
    }
  }
}
</script>

<style scoped>
.carousel-container {
  text-align: center;
  position: relative;
  margin: 0 auto;
}
.carousel-images {
  position: relative;
}
.carousel-image {
  margin: 0 auto;
  display: block;
  object-fit: contain;
  border-radius: 4px;
}
.carousel-size-filter .carousel-image {
  max-width: 77%;
  max-height: 77%;
}
.carousel-size-form .carousel-image {
  width: 100%;
  height: 200px;
  object-fit: contain;
}
.carousel-size-incident .carousel-image {
  width: 100%;
  height: 50vh;
  object-fit: contain;
}
.no-image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #999;
  font-size: 14px;
  border: 1px dashed #ccc;
  border-radius: 4px;
}
.carousel-controls {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s;
}
.carousel-container:hover .carousel-controls {
  opacity: 1;
}
.carousel-control {
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 10px;
  padding: 0;
  line-height: 1;
}
.carousel-control:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.carousel-indicators-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}
.carousel-indicators-row {
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}
.carousel-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.carousel-dot.active {
  background-color: #007bff;
}
</style>